const decidedlyGUID = {
  methods: {
    genGUID: function () {
      const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let autoId = ''
      for (let i = 0; i < 20; i++) {
        autoId += CHARS.charAt(
          Math.floor(Math.random() * CHARS.length)
        )
      }
      return autoId
      // return (((1+Math.random())*0x10000)|0).toString(16).substring(1)
    }
  }
}

export default decidedlyGUID
